module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/WhichPlanSection/comprehensive-standard-451f35026712dd2b422fbabb893fed5b.png";